import { TrianglePointIcon } from '@/assets/icons/TrianglePointIcon';
import styles from './formerrordisplay.module.scss';

export interface FormErrorDisplayProps {
    errorCount: number;
    errorMessage?: React.ReactNode;
}

export function FormErrorDisplay({ errorCount, errorMessage }: FormErrorDisplayProps): React.JSX.Element {
    if (!errorMessage && errorCount === 0) {
        return <></>;
    }

    if (errorMessage) {
        return (
            <div className={styles.inlineErrorMessage} role="alert">
                <span className={styles.inlineErrorIcon} aria-hidden="true">
                    <TrianglePointIcon />
                </span>
                <span className={styles.inlineErrorText}>{errorMessage}</span>
            </div>
        );
    }

    return (
        <div className={styles.errorMessage} role="alert" data-errorcount={errorCount}>
            {`Please fix the ${errorCount} error${errorCount > 1 ? 's' : ''} in the form below`}
        </div>
    );
}
